import type { SVGProps } from 'react';
const SvgIconX = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M8 6.94 5.525 4.463a.75.75 0 0 0-1.06 1.061L6.938 8l-2.475 2.475a.75.75 0 1 0 1.061 1.06L8 9.062l2.475 2.475a.75.75 0 1 0 1.06-1.061L9.062 8l2.475-2.475a.75.75 0 0 0-1.061-1.06z"
    />
  </svg>
);
export default SvgIconX;
